import {
    Grid,
    Typography,
    WithStyles,
    withStyles,
    Paper,
    Theme,
    createStyles,
  } from "@material-ui/core";
  import React, { Component, ReactNode } from "react";
  import { connect } from "react-redux";
import {CloseOutlined as CloseIcon} from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const userStyles = (theme: Theme) => createStyles({
  toaster: {
    padding: 12,
    maxWidth: 499,
    boxShadow: '0px 5px 14px rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    border: '1px solid #E7E7E7',    
    transition: 'opacity 2s ease-in',
    '& .closeIcon': {
      cursor: 'pointer',
      position: 'absolute',
      right: 12,
      top: 6,
      height: '100%',
    },
  },
  
  success: {
    backgroundColor: '#E5F4E8',
    '&::before':{
    background: '#21A67A',
    },
    '& .closeIcon': {
      '& svg': {
        fill: '#21A67A',
        fontSize: 24
      }
    },
    '&>svg': {
      fill: '#21A67A',
      fontSize: 30
    }
  },
  warning: {
    backgroundColor: '#FFFBEC',
    '& .closeIcon': {
      '& svg': {
        fill: '#FFCC00',
        fontSize: 24
      }
    },
    '&::before':{
      background: '#FFCC00',
    },
    '&>svg': {
      fill: '#FFCC00',
      fontSize: 30
    }
  },
  error: {
    backgroundColor: '#FFEFEE',
    '& .closeIcon': {
      '& svg': {
        fill: '#F44335',
        fontSize: 24
      }
    },
    '&::before':{
      background: '#F44335',
    },
    '&>svg': {
      fill: '#F44335',
      fontSize: 30
    }
  },
  topRightToaster : {
    position: "fixed",
    right: 10,
    top: 15,       
    zIndex: 999,
    
    '&::before': {
      content: '" "',
      width: '0.375rem',
      height: 58,
      borderRadius: 5,
      position: 'absolute',
      top: 12,
      left: 12,
    },
    
    '& .errorMessage': {
      fontSize: '14px',
      lineHeight: '16px',
      color: '#666',
      textAlign: 'left'
    },
    '& h6': {
      textAlign: 'left',
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '20px',
      color: '#333',
      margin: '0px 0px 4px 0px'
    }
  },
    bottomRightToaster:{ 
        position: "absolute",
        right: 4,
        bottom: 10,       
        zIndex: 4,
        '&::before': {
          content: '" "',
          width: '0.375rem',
          height: 58,
          borderRadius: 5,
          position: 'absolute',
          top: 12,
          left: 12,
        },
        '& .cacelIcon': {
          '&>svg': {
            fill: '#F44335',
            fontSize: 30
          }
        },
        '& .errorMessage': {
          fontSize: '14px',
          lineHeight: '16px',
          color: '#666',
          textAlign: 'left'
        },
        '& h6': {
          textAlign: 'left',
          fontWeight: 'bold',
          fontSize: '16px',
          lineHeight: '20px',
          color: '#333',
          margin: '0px 0px 4px 0px'
        }
      },
      textCentre:{
        textAlign: 'center',
      }
})

interface MyPATToasterProps extends WithStyles<typeof userStyles> {
    toasterAlignment: string,
    icon: ReactNode,
    toasterType: string,
    subPara: string;
    heading: string;
    handleClose:Function;
    autoClose:boolean;
  }
  
  class MyPATToaster extends Component<MyPATToasterProps> {
    constructor(props:MyPATToasterProps){
		super(props);
    }  
    componentDidMount(){
      if (this.props.autoClose) {
        setTimeout(() => this.props.handleClose(), 3000);
      }
    }
    render() {
        const { toasterType, heading, subPara, classes, toasterAlignment, icon,handleClose } = this.props;
        
        return(
        <>
         <Grid
            className={[(toasterAlignment === 'bottomRight' ?
            classes.bottomRightToaster : classes.topRightToaster), 
            toasterType === 'success' && classes.success,
            toasterType === 'warning' && classes.warning,
            toasterType === 'error' && classes.error,
            classes.toaster].join(' ')}
            container justify="flex-start" alignItems="center"
          >           
              <Grid item xs={2}>
                <Grid className={classes.textCentre}>
                {
                  (toasterType === 'error') &&
                  <Grid className={classes.error}>{icon} </Grid>
                }
                {
                  (toasterType === 'success') &&
                  <Grid className={classes.success}>{icon} </Grid>
                }
                {
                  (toasterType === 'warning') &&
                  <Grid className={classes.warning}>{icon} </Grid>
                  
                }
                </Grid>
              </Grid>
              <Grid item xs={10}>
              <h6>{heading}</h6>
              <div className="errorMessage">
              {subPara}
              </div>
              </Grid>
              <Grid className="closeIcon">
                <span onClick={()=>{handleClose();}}><CloseIcon /></span>
              </Grid>
          </Grid>
        </>);
    }
  }

  // @ts-ignore
  export default connect()(withStyles(userStyles)(MyPATToaster));